import { render, staticRenderFns } from "./loginWithPhone.vue?vue&type=template&id=54b0e5d7&scoped=true&"
import script from "./loginWithPhone.vue?vue&type=script&lang=ts&"
export * from "./loginWithPhone.vue?vue&type=script&lang=ts&"
import style0 from "./loginWithPhone.vue?vue&type=style&index=0&id=54b0e5d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0e5d7",
  null
  
)

export default component.exports